import React from "react";

const ExtrapayInfoNote = ({ text }) => (
  <div
    className="flex align-items-start gap-2 p-3 border-round-lg"
    style={{ backgroundColor: "#F3F6FB" }}
  >
    <i className="pi pi-info-circle text-sm mt-1" style={{ color: "#5C6B8A" }} />
    <p className="text-sm m-0 line-height-3" style={{ color: "#3D4A63" }}>
      {text}
    </p>
  </div>
);

export default ExtrapayInfoNote;
